export const releasesConstants = {
  GET_NEW_RELEASES_REQUEST: 'GET_NEW_RELEASES_REQUEST',
  GET_NEW_RELEASES_SUCCESS: 'GET_NEW_RELEASES_SUCCESS',
  GET_NEW_RELEASES_FAILURE: 'GET_NEW_RELEASES_FAILURE',
};
